import { DateTime } from 'luxon';
import { dateIsMinHoursAheadOfReferenceDate, dateIsWeeksAfterReferenceDate } from '../dates.js';
/**
 * Function to check if the registration dates that are provided are not violating constraints
 *
 * @param optInOpensAt -
 * @param optInClosesAt -
 * @param timezoneIso - ISO Timezone representation (e.g., Europe/London, America/Los_Angeles)
 *
 * @returns boolean indicating if the registration dates are valid.
 */
export const validateRegistrationDates = (optInOpensAt, optInClosesAt, timezoneIso) => {
    const now = DateTime.now().setZone(timezoneIso);
    // [CONSTRAINT] Engagement open date is at least 12 hours ahead.
    if (!dateIsMinHoursAheadOfReferenceDate(optInOpensAt, now, 12)) {
        return false;
    }
    // [CONSTRAINT] Engagement closes after the opening date
    if (optInClosesAt.startOf('day') <= optInOpensAt) {
        return false;
    }
    // [CONSTRAINT] Minimum 24 hour registration window. Opt-In Closes needs to be
    // at least 24 hours after the Opt-In Opens At.
    if (!dateIsMinHoursAheadOfReferenceDate(optInClosesAt, optInOpensAt, 24)) {
        return false;
    }
    // [CONSTRAINT] Engagement closes at least following calendar week from now.
    if (!dateIsWeeksAfterReferenceDate(optInClosesAt, now, 1)) {
        return false;
    }
    return true;
};
